module.exports = __webpack_public_path__ + "static/media/Home-TealWaveMobile.2a070644.svg";